import {ContentVisibilityRuleRestDto as MenuContentVisibilityRuleRestDto} from "@/api/pharma-cms-menu/models";
import {ContentVisibilityRuleRestDto as ContentPageContentVisibilityRuleRestDto} from "@/api/pharma-cms-content-page/models";
import {ContentVisibilityRuleRestDto as PopupContentVisibilityRuleRestDto} from "@/api/pharma-cms-popup/models";
import {VisibilityRuleTypeEnum} from "@/api/enums/visibility-rule-type-enum";

export class ContentVisibilityRuleRestDtoModel
    implements
        MenuContentVisibilityRuleRestDto,
        ContentPageContentVisibilityRuleRestDto,
        PopupContentVisibilityRuleRestDto {

    type_code: VisibilityRuleTypeEnum;
    product_filter_code?: string | null;
    begin_date?: string | null;
    end_date?: string | null;
    client_group_codes: string[] | null;

    constructor(type_code: VisibilityRuleTypeEnum, product_filter_code: string | null, begin_date: string | null, end_date: string | null) {
        this.type_code = type_code;
        this.product_filter_code = product_filter_code;
        this.begin_date = begin_date;
        this.end_date = end_date;
        this.client_group_codes = [];
    }

    public static createWithDefaults(): ContentVisibilityRuleRestDtoModel {
        return new this(VisibilityRuleTypeEnum.HIDE, null, null, null);
    }
}
